<template>
  <component
    :is="imageComponent"
    v-if="imageComponent"
    :class="{ icon: !noIconClass }"
    :aria-hidden="ariaHidden ? 'true' : undefined"
  />
</template>

<script setup lang="ts">
import { type CreateElement, type VNode, computed, withDefaults, getCurrentInstance } from 'vue';

export interface SvgComponent {
  render: (h: CreateElement) => VNode;
}

export type SvgIconProps = {
  // the "sting" is for tests only
  image?: SvgComponent | Record<any, any> | string;
  noIconClass?: boolean;
  ariaHidden?: boolean;
};

const props = withDefaults(defineProps<SvgIconProps>(), {
  ariaHidden: true,
  image: undefined,
});

// Getting current Vue instance
const instance = getCurrentInstance();

// SVG is a Vue-Component
const imageComponent = computed(() => {
  if (
    typeof props.image === 'object' &&
    props.image.render &&
    typeof props.image.render === 'function'
  ) {
    const image = props.image as SvgComponent;
    return {
      render: (h: CreateElement) => image.render.call(instance?.proxy, h),
    };
  }
  return undefined;
});
</script>
